<template>
  <div class="cover_anchor" @click="active_anchor"></div>
</template>
<script>
import Cookies from 'js-cookie';
export default {
  name: 'anchor_link_index',
  props: {
    editData: {
      type: Object,
      default: null
    }
  },
  methods: {
    active_anchor() {
      let type = this.editData.type;
      let id = '';
      if (this.editData.type === 'cur_page') {
        id = this.editData.cur_page_value;
        //本页面锚点跳转逻辑
        // this.animateFn(id);
      } else {
        //跨页面锚点跳转
        id = this.editData.other_page_value;
      }
      let path = this.editData.site_section.routerPath ? this.editData.site_section.routerPath : '';
      this.templet.clickTime(() => {
        this.templet.active_anchor(type, id, path);
      });

    },
  },
  components: {},
  mounted() {
    console.log(this.editData);
  }
};
</script>

<style scoped lang="scss">
.cover_anchor {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/set_link/components/anchor_link.vue